import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { END_DATE_GREATER, PAYMENT_MODE, SELECT_BOTH_DATES, USER_ROLES } from '@shared/constant/shared.constant';
import { ToastService } from '@shared/services/toast.service';
import { TransactionService } from '@core/services/transaction.service';
import { formatDate } from 'date-fns';
import { MenuItem } from 'primeng/api';
import { DriverService } from '@core/services/driver.service';
import { SuperAdminService } from '@core/services/super-admin.service';
export enum InvoiceType {
  BookingInvoice = 1,
  OneTimeInvoice = 2
}
import { InvoicePaymentStatus, PaymentMode } from '@core/models/api-response.model';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { CommonFunctions } from '@shared/common-functions';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-custom-invoice',
  templateUrl: './custom-invoice.component.html',
  styleUrls: ['./custom-invoice.component.scss']
})
export class CustomInvoiceComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  invoiceList: any[] = [];
  invoiceForm: FormGroup;
  companyId: string;
  companyList: any;
  companyListWithAll: any[];
  itemsPerPage: number = 10;
  totalRecords: number;
  DateSlot = [];
  startdate: Date | string = '';
  enddate: Date | string = '';
  showPicker: boolean = true;
  showAsterisk: boolean = false;
  selectedCompanies = [];
  selectedParkingLots = [];
  activeItem: any;
  items: MenuItem[] | undefined;
  pageNumber: number = 1;
  first: number = 0;
  invoiceNumber: string;
  excelFile: any[] = [];
  role: string;
  isAlternateDesign: boolean = false;
  selectedDateSlot: string = ''
  invoicePaymentStatus = InvoicePaymentStatus
  parkingLotByStatesList: any = [];
  parkingLotByStatesListWithAll: any[];
  showParkingLotAsterisk: boolean = false;
  hideAdvanceFilter: boolean = true;
  constructor(
    private readonly transactionService: TransactionService,
    private readonly service: SuperAdminService,
    private readonly driverService: DriverService,
    private readonly toastService: ToastService,
    private readonly encryptStorage: EncryptionStorageService) { }

  ngOnInit() {
    this.role = this.encryptStorage.getItem('roleName');
    this.companyId = this.encryptStorage.getItem('companyId');
    this.DateSlot = [
      { name: 'Custom', value: '', flag: true },
      { name: 'Last 30 days', value: 30, flag: false },
      { name: 'Last 60 days', value: 60, flag: false },
      { name: 'Last 90 days', value: 90, flag: false },
    ]
    if (this.role !== USER_ROLES.SUPER_ADMIN) {
      this.performActions();
    } else {
      this.getCompanyList(true);
    }
  }

  async performActions(): Promise<void> {
    await this.getParkingLotByStatesName();
    this.search();
  }

  showData(rowData: any) {
    this.isAlternateDesign = true;
    const actionMap = {
      downloadInvoice: () => {
        this.downloadInvoice(rowData.id)
      }
    }
    this.items = [
      {
        items: [
          {
            label: '',
            icon: '',
            escape: false,

          },
          {
            label: 'View Invoice',
            icon: 'common-icon view-profile',
            command: actionMap.downloadInvoice,
          },
        ]
      },
    ];
  }

  exportMenu() {
    this.isAlternateDesign = false;
    this.items = [
      {
        items: [
          {
            label: 'Export',
            icon: 'pi pi-download',
            command: () => {
              this.getParkingLotInvoiceForDriverCustomForExcel();
            }
          },
        ]
      },
    ];

  }

  searchButton() {
    this.pageNumber = 1;
    this.first = 0;
    if (this.role !== USER_ROLES.SUPER_ADMIN || (this.selectedCompanies?.length > 0)) {
      this.search();
    } else {
      this.showAsterisk = true;
    }
  }

  search() {
    if (this.startdate && this.enddate) {
      const startDate = new Date(this.startdate);
      let endDate = this.enddate instanceof Date ? this.enddate : new Date(this.enddate);
      endDate.setHours(23, 59, 59, 999)
      if (startDate > endDate) {
        this.toastService.showToastMessage('error', 'Error', END_DATE_GREATER);
        return;
      }
    } else if (this.startdate || this.enddate) {
      this.toastService.showToastMessage('error', 'Error', SELECT_BOTH_DATES);
      return;
    }
    if (this.selectedCompanies?.length === 0) {
      this.showAsterisk = true;
    }

    if (this.selectedParkingLots?.length === 0) {
      this.showParkingLotAsterisk = true;
      return;
    }
    const req = {
      pageSize: this.itemsPerPage,
      pageNumber: this.pageNumber,
      name: "",
      phoneNumber: "",
      driverEmail: "",
      invoiceNumber: this.invoiceNumber,
      startDate: this.startdate,
      endDate: this.enddate,
      timeZone: Utility.getLocalTimeZone(),
      InvoiceType: InvoiceType.OneTimeInvoice,
      parkingLotName: this.selectedParkingLots.map(item => item.name).filter(name => name !== null && name !== undefined),
      companyIds: this.role === USER_ROLES.SUPER_ADMIN
        ? this.selectedCompanies.map(company => company.id).filter(id => id !== null && id !== undefined)
        : [this.companyId]
    }
    this.getParkingLotInvoiceForDriverCustom(req);
  }

  getFlagClass(iso: string): string {
    const lowerCaseIso = iso?.toLowerCase();
    return `fi fi-${lowerCaseIso}`;
  }
  downloadInvoice(id) {
    
    const req = {
      InvoiceType: InvoiceType.OneTimeInvoice,
      id: id
    };
    this.driverService.downloadInvoice(req).pipe(autoUnsubWith(this.destroyRef)
    ).subscribe({
      next: (_response) => {
        const url = _response.data as string;
        window.open(url, "_blank");
      },
      error: (er: Error) => {
        this.toastService.showToastMessage('error', 'Error', er.message);
      }
    });
  }

  onDateSlotChange(event) {
    const selectedOption = this.DateSlot.find(option => option.value === event.value);
    if (selectedOption) {
      const currentDate = new Date();
      this.startdate =
        this.formatDateToString(new Date(currentDate.getTime() - (selectedOption.value * 24 * 60 * 60 * 1000)));
      this.enddate = this.formatDateToString(currentDate);
      if (this.startdate == this.enddate) {
        this.startdate = '';
        this.enddate = '';
      }
      this.showPicker = selectedOption.flag;
    }
  }
  formatDateToString(date: Date): string {
    return formatDate(date, 'MM/dd/yyyy HH:mm');
  }

  getParkingLotInvoiceForDriverCustom(req: any): void {
    this.transactionService.getParkingLotInvoiceForDriverCustom(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.totalRecords = response.totalRecords;
        this.invoiceList = response.data;
      },
      error: () => {
        this.invoiceList = [];
      }
    });
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.pageNumber = event.page + 1;
    CommonFunctions.scrollTopRow('top');
    this.search();
  }

toggleHideAdvanceFilter() {
    this.hideAdvanceFilter = !this.hideAdvanceFilter;;
  }

reset() {
    this.pageNumber = 1;
    this.first = 0;
    this.startdate = ''
    this.enddate = '';
    this.invoiceNumber = '';
    this.showPicker = true;

    this.selectedDateSlot = '';
    if (this.role !== USER_ROLES.SUPER_ADMIN) {
      this.getParkingLotNamesByCompanyIds();
    } else {
      this.getCompanyList(true);
    }
    this.showAsterisk = false;
  }
  onParkingLotSelectionChange(event) {
    this.showParkingLotAsterisk = false;
    const selectedValues = event.value as string[];
    if (selectedValues.includes('all')) {
      if (selectedValues?.length === this.parkingLotByStatesListWithAll?.length) {
        return;
      }
      this.selectedParkingLots = this.parkingLotByStatesList.map(lot => lot.name);
    } else {
      const index = this.selectedParkingLots.indexOf('all');
      if (index !== -1) {
        this.selectedParkingLots.splice(index, 1);
      }
      this.selectedParkingLots = selectedValues;
    }
  }

  getParkingLotInvoiceForDriverCustomForExcel(): void {
    const req = {
      pageSize: 0,
      pageNumber: 0,
      name: "",
      phoneNumber: "",
      driverEmail: "",
      invoiceNumber: this.invoiceNumber,
      startDate: this.startdate,
      endDate: this.enddate,
      timeZone: Utility.getLocalTimeZone(),
      parkingLotName: this.selectedParkingLots.map(item => item.name).filter(name => name !== null && name !== undefined),
      companyIds: this.role === USER_ROLES.SUPER_ADMIN
        ? this.selectedCompanies.map(company => company.id).filter(id => id !== null && id !== undefined)
        : [this.companyId]
    }
    this.transactionService.getParkingLotInvoiceForDriverCustom(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.excelFile = response.data;
        this.export();
      },
      error: () => {
        this.excelFile = [];
        
      }
    });
  }
  onSelectionChange(event) {
    this.showAsterisk = false;
    const selectedValues = event.value as string[];
    if (selectedValues.includes('all')) {
      if (selectedValues?.length === this.companyListWithAll?.length) {
        return;
      }
      this.selectedCompanies = this.companyList.map(lot => lot.id);
    } else {
      const index = this.selectedCompanies.indexOf('all');
      if (index !== -1) {
        this.selectedCompanies.splice(index, 1);
      }
      this.selectedCompanies = selectedValues;
    }
    this.getParkingLotByStatesName();
  }

  async getCompanyList(initial: boolean = false) {
    
    const searchPayload = {
      search: '',
      sort: 1
    };
      const response = await this.service.getCompanyList(searchPayload).toPromise();
      this.companyList = response;
      this.companyListWithAll = [...this.companyList];
      this.selectedCompanies = this.companyList;
      this.getParkingLotByStatesName(initial);
      this.pageNumber = 1;
      this.first = 0;
      this.search();
  }

  async getParkingLotByStatesName(initial: boolean = false): Promise<void> {
    
    const req = {
      companyIds: this.role === USER_ROLES.SUPER_ADMIN
        ? this.selectedCompanies.map(company => company.id).filter(id => id !== null && id !== undefined)
        : [this.companyId]
    };
    try {
      const response = await this.service.getParkingLotNamesByCompanyIds(req).toPromise();
      this.parkingLotByStatesList = response.data;
      this.parkingLotByStatesListWithAll = [...this.parkingLotByStatesList];
      this.selectedParkingLots = this.parkingLotByStatesList;
      this.showParkingLotAsterisk = false;
      if (initial) {
        this.search();
      }
      
    } catch (err) {
      
      this.parkingLotByStatesList = [];
      this.parkingLotByStatesListWithAll = []
      this.selectedParkingLots = [];
    }
  }

  getParkingLotNamesByCompanyIds() {
    const req = {
      companyIds: this.role === USER_ROLES.SUPER_ADMIN
        ? this.selectedCompanies.map(company => company.id).filter(id => id !== null && id !== undefined)
        : [this.companyId]
    };
    this.service.getParkingLotNamesByCompanyIds(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        
        this.parkingLotByStatesList = response.data;
        this.parkingLotByStatesListWithAll = [...this.parkingLotByStatesList];
        this.selectedParkingLots = this.parkingLotByStatesList;
        this.search();
      }
    });
  }

  export() {
    if (this.excelFile) {
      const headers = [
        { header: 'S. No.', key: 'index', formatter: (value) => value + 1 },
        { header: 'Name', key: 'userType', formatter: (_value, item) => item.userType === 'Group Operator' ? item.groupName : item.name },
        { header: 'Invoice Number', key: 'invoiceNumber' },
        { header: 'Email', key: 'email' },
        { header: 'Mobile Number', key: 'phoneNumber', formatter: (_value, item) => `${item.countryCode} ${item.phoneNumber}` },
        { header: 'User Type', key: 'userType' },
        { header: 'Company', key: 'company' },
        { header: 'Parking Lot', key: 'parkingLotName' },
        { header: 'Address', key: 'address' },
        { header: 'Generated By', key: 'generatedBy' },
        { header: 'Invoice Date', key: 'billingDate' },
        { header: 'Created Date', key: 'dateCreated' },
        { header: 'Amount ($)', key: 'totalAmount' },
        { header: 'Payment Mode', key: 'bookingPaymentMode', formatter: (value) => value === PaymentMode.Online ? PAYMENT_MODE.ONLINE : value === PaymentMode.Offline ? PAYMENT_MODE.OFFLINE : '', },
        { header: 'Payment Status', key: 'status' }
      ];

      const dataWithIndex = this.excelFile.map((item, index) => ({
        ...item,
        index, // Add the index to each row
      }));

      return CommonFunctions.exportToExcel(dataWithIndex, headers, 'Custom Invoice List_export_')
    }
  }

}
